export default __webpack_public_path__ + "static/media/dynamic-msg.1cf9809a.svg";